/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AdvancedEstimationStatus = {
    NotSpecified: 'NotSpecified',
    Success: 'Success',
    Failure: 'Failure',
    Unable: 'Unable',
} as const;
export type AdvancedEstimationStatus = typeof AdvancedEstimationStatus[keyof typeof AdvancedEstimationStatus];

